import React, { useState } from 'react';
import MessageLabel from './MessageLabel';
import { IconCopy } from '../../Assets/MyIcons';


const AdminCustomURLCopy = ({ link, fieldName, className, labelClassName }) => {
    const [isCopied, setIsCopied] = useState(false);
    const copyToClipboard = () => {
        navigator.clipboard?.writeText(link)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 2000);
            })
            .catch((error) => {
                console.error('Failed to copy text: ', error);
            });
    };

    return (
        <div>
            {fieldName && <MessageLabel text={fieldName} className={labelClassName} />}
            <div className="position-relative d-flex align-items-center mb-3">
                {isCopied && <span className='position-absolute copy-reply theme-button-text-color button-bg-color px-2 py-1 rounded-2' style={{ top: '-35px', right: '0' }}>{'Copied!'}</span>}
                <input type="text" className={`custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color ${className}`} value={link} readOnly style={{ paddingRight: '40px' }} />
                <button onClick={copyToClipboard} className='border-0 copy-board-container bg-transparent position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    <IconCopy styled={{ width: "20px", height: "20px", className: "" }} />
                </button>
            </div>
        </div>
    );
};

export default AdminCustomURLCopy;
